<template>
  <div>

    <button @click="init" class="btn btn-sm btn-danger mb-4">Обновить</button>
    <div class="row">
      <div class="col-6">
        <label>Дата</label>
        <datetime v-model="date" @input="init" class="from-control" type="date" format="dd/MM/yyyy">
        </datetime>
      </div>
      <!-- <div class="col-6">
        <label>Дата с</label>
        <datetime v-model="from_at" @input="init" class="from-control" type="datetime" format="dd/MM/yyyy HH:mm:ss">
        </datetime>
      </div>
      <div class="col-6">
        <label>Дата по</label>
        <datetime v-model="till_at" @input="init" class="from-control" type="datetime" format="dd/MM/yyyy HH:mm:ss">
        </datetime>
      </div> -->
    </div>
    <ListMap 
      :cardLink="`item_shop`" 
      v-if="done === true" 
      :defaultLat="lstLat" 
      :polylineItems="this.points"
      :defaultLon="lstLon"
      :params="{ user_id: id }" 
      :polyline="{ color: 'blue',  latlngs: data }" 
    />
  </div>
</template>
<script>
import ListMap from '@/components/ListMap';
export default {
  components: {
    ListMap
  },
  name: "products",
  props: {
    id: {
      default: null,
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$loading(true);
      this.$http.get(`users/${this.id}/points`, { 
        params: { 
          date: this.date ? this.date.split('T')[0] : '',
          // from_at: this.from_at, 
          // till_at: this.till_at 
        } 
      }).then(response => {
        
        this.data = []
        try {
          const content = response.data;
          const data = content.data;
          this.points = data.reverse()
          // this.from_at = content.from_at;
          // this.till_at = content.till_at;

          if (data.length) {
            for (let i = 0; i < data.length; i++) {
              this.data.push([data[i].shop.lat, data[i].shop.lon]);
            }
            this.lstLat = data[0].shop.lat;
            this.lstLon = data[0].shop.lon;
          }
        } catch (error) {

        }
        this.done = true;
        this.$loading(false);
      });
    }
  },
  data() {
    return {
      data: [],
      lstLat: 0,
      points: [],
      lstLon: 0,
      done: false,
      from_at: null,
      till_at: null,
      date: new Date().toISOString(),
    };
  },
};
</script>
